import { get, isNil, isUndefined, reduce, set, forEach } from 'lodash';
import { validateFormField } from '../modelValidator';

const message = 'This is a required field.';
const required = {
  message
};

// Helper functions
/*
 * Converts { name: 'al', description: 'awesome' }
 * To { name: { defaultValue: 'al', required: true}, description : { defaultValue: 'awesome' } }
 */
export function mapFormFields(model, required = [], optionals = []) {
  return [...required, ...optionals].reduce(
    (target, field) => mapField(target, model, field, ~required.indexOf(field)), {})
}

export function mapField(target, source, field, isRequired = false) {
  if (isRequired) {
    set(target, `${field}.required`, required);
  }
  set(target, `${field}.value`, get(source, field))
  return set(target, `${field}.defaultValue`, get(source, field));
}

export function updateFormFields(model, prop, newValue) {
  const reverted = get(model, `${prop}.defaultValue`) === newValue;
  set(model, `${prop}.value`, (reverted) ? undefined : newValue);
  set(model, `${prop}.errors`, (reverted) ? null : validateFormField(prop, model));
  //return model;
}

/*
 * Converts { name: { required: true, value: 'al', defaultValue: 'a', errors: [] } }
 * To { name: 'al' }
 */
export function reduceToValues(model) {
  return reduce(model, (obj, prop, name) =>
    !isUndefined(get(prop, 'value')) ? set(obj, name, get(prop, 'value')) : obj,
    {}
  );
}

export function fieldsHasErrors(model) {
  return reduce(model, (hasErrors, obj, prop) =>
    get(model, `${prop}.errors.length`, false) || hasErrors,
    false
  );
}

export function validateForm(form, fields) {
  forEach(form, (prop, key) => {
    if (fields.required.includes(key) && isNil(prop.defaultValue) && isNil(prop.value)) {
      updateFormFields(form, key, prop.value);
    }
  })
}

export function formFieldProperties(model, prop, label, {onChange, onBlur} = {}) {
  const field = get(model, `${prop}`, {});

  return {
    'data-id': `${model}${prop}`,
    defaultValue: field.defaultValue,
    floatingLabelText: label,
    errorText: field.required ? get(field, 'errors[0]') : undefined,
    onChange,
    onBlur
  };
}

export function markForDeletion(model, prop) {
  set(model, `${prop}.deleted`, Symbol.for('_deleted_'));
}



// WEBPACK FOOTER //
// ./shared/lib/form.js